import React from 'react';
import Icon from '../../../components/AppIcon';

const LocationHours = () => {
  const businessInfo = {
    location: "Juba, South Sudan",
    phone: "+211 915 497 014",
    email: "hello@chapatiplus.com",
    hours: "Daily: 8:00 AM - 10:00 PM"
  };

  const handleCallClick = () => {
    window.open(`tel:${businessInfo?.phone}`, '_self');
  };

  const handleEmailClick = () => {
    window.open(`mailto:${businessInfo?.email}`, '_self');
  };

  const handleLocationClick = () => {
    window.open('https://www.google.com/maps/search/?api=1&query=Juba+South+Sudan', '_blank');
  };

  return (
    <div className="bg-card border-t border-border py-6 md:py-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          <button
            onClick={handleLocationClick}
            className="flex items-center gap-3 p-4 bg-background rounded-lg hover:bg-muted transition-colors duration-300 text-left"
          >
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name="MapPin" size={24} color="var(--color-primary)" />
            </div>
            <div className="min-w-0">
              <p className="text-sm text-muted-foreground mb-1">Location</p>
              <p className="text-base font-semibold text-foreground truncate">{businessInfo?.location}</p>
            </div>
          </button>

          <button
            onClick={handleCallClick}
            className="flex items-center gap-3 p-4 bg-background rounded-lg hover:bg-muted transition-colors duration-300 text-left"
          >
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name="Phone" size={24} color="var(--color-primary)" />
            </div>
            <div className="min-w-0">
              <p className="text-sm text-muted-foreground mb-1">Call Us</p>
              <p className="text-base font-semibold text-foreground truncate">{businessInfo?.phone}</p>
            </div>
          </button>

          <button
            onClick={handleEmailClick}
            className="flex items-center gap-3 p-4 bg-background rounded-lg hover:bg-muted transition-colors duration-300 text-left"
          >
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name="Mail" size={24} color="var(--color-primary)" />
            </div>
            <div className="min-w-0">
              <p className="text-sm text-muted-foreground mb-1">Email</p>
              <p className="text-base font-semibold text-foreground truncate">{businessInfo?.email}</p>
            </div>
          </button>

          <div className="flex items-center gap-3 p-4 bg-background rounded-lg">
            <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name="Clock" size={24} color="var(--color-primary)" />
            </div>
            <div className="min-w-0">
              <p className="text-sm text-muted-foreground mb-1">Hours</p>
              <p className="text-base font-semibold text-foreground">{businessInfo?.hours}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationHours;